/* eslint-disable max-lines */
import { createTheme, type ThemeOptions, type Theme } from '@mui/material';
import { vars } from '@tgtg/kit';

import cvi from './cvi';

const Tenon = 'Tenon,"Open Sans",Roboto,Arial,sans-serif';
const KongaPro = 'KongaPro,"Open Sans",Roboto,Arial,sans-serif';
const Korolev = 'Korolev,"Open Sans",Roboto,Arial,sans-serif';

export default {
  fontSize: 16,
  fontFamily: Tenon,
  h1: {
    fontFamily: Tenon,
    fontWeight: 700,
    fontSize: 26.6,
    lineHeight: '32px',
    letterSpacing: '0.01em',
  },
  h1Konga: {
    fontFamily: KongaPro,
    fontWeight: 400,
    fontSize: 48,
    lineHeight: '56px',
    letterSpacing: '0.01em',
  },
  h2: {
    fontFamily: Tenon,
    fontWeight: 700,
    letterSpacing: '0.005em',
    fontSize: 23,
    lineHeight: '24px',
  },
  h2Konga: {
    fontFamily: KongaPro,
    fontWeight: 400,
    letterSpacing: '0.005em',
    fontSize: 32,
    lineHeight: '38px',
  },
  h3: {
    fontFamily: Tenon,
    fontWeight: 700,
    letterSpacing: '0.01em',
    fontSize: 20.3,
    lineHeight: '24px',
  },
  h3Konga: {
    fontFamily: KongaPro,
    fontWeight: 400,
    letterSpacing: '0.048em',
    fontSize: 24,
    lineHeight: '26px',
  },
  h4: {
    fontFamily: Tenon,
    fontWeight: 700,
    fontSize: 18,
    lineHeight: '24px',
    letterSpacing: '0.017em',
  },
  h5: {
    fontFamily: Tenon,
    fontWeight: 700,
    lineHeight: '24px',
    fontSize: 16,
    letterSpacing: '0.015em',
  },
  h6: {
    fontFamily: Tenon,
    fontWeight: 700,
    lineHeight: '16px',
    fontSize: 13.3,
    letterSpacing: '0.015em',
  },
  subtitle1: {
    fontFamily: Tenon,
    fontWeight: 500,
    fontSize: 19.2,
    lineHeight: '24px',
    letterSpacing: '0.01em',
  },
  subtitle2: {
    fontFamily: Tenon,
    fontWeight: 700,
    fontSize: 16,
    lineHeight: '24px',
    letterSpacing: '0.01em',
  },
  body1: {
    fontFamily: Tenon,
    fontWeight: 400,
    fontSize: 16,
    lineHeight: '24px',
    letterSpacing: '0.005em',
  },
  bodyBold1: {
    fontFamily: Tenon,
    fontWeight: 700,
    fontSize: 16,
    lineHeight: '24px',
    letterSpacing: '0.005em',
  },
  body2: {
    fontFamily: Tenon,
    fontWeight: 400,
    fontSize: 13.3,
    lineHeight: '16px',
    letterSpacing: '0.002em',
  },
  bodyBold2: {
    fontFamily: Tenon,
    fontWeight: 700,
    fontSize: 13.3,
    lineHeight: '16px',
    letterSpacing: '0.002em',
  },
  caption: {
    fontFamily: Tenon,
    fontWeight: 400,
    fontSize: 16,
    lineHeight: '16px',
    letterSpacing: '0.005em',
  },
  eyebrow: {
    fontFamily: Tenon,
    fontWeight: 500,
    fontSize: 13.33,
    lineHeight: '16px',
    letterSpacing: '0.05em',
  },
  overline: {
    fontFamily: Tenon,
    fontWeight: 500,
    fontSize: 13.3,
    lineHeight: '24px',
  },
  buttonLarge: {
    fontFamily: Tenon,
    fontWeight: 700,
    fontSize: 19.2,
    lineHeight: '24px',
    letterSpacing: '0.0075em',
  },
  button: {
    fontFamily: Tenon,
    fontWeight: 500,
    fontSize: 16,
    lineHeight: '24px',
    letterSpacing: '0.005em',
  },
  link: {
    fontFamily: Tenon,
    fontWeight: 500,
    fontSize: 16,
    lineHeight: '24px',
    color: cvi.primary[30],
    letterSpacing: '0.005em',
    textDecorationLine: 'underline',
  },
  link2: {
    fontFamily: Tenon,
    fontWeight: 500,
    fontSize: 13.3,
    lineHeight: '16px',
    color: cvi.primary[30],
    letterSpacing: '0.002em',
    textDecorationLine: 'underline',
  },
  assistiveText: {
    display: 'none',
  },
  KorolevHeavyH1: {
    fontFamily: Korolev,
    fontSize: 44.2,
    lineHeight: '44px',
    letterSpacing: '-0.01em',
  },
  KorolevHeavyH2: {
    fontFamily: Korolev,
    fontSize: 36.8,
    lineHeight: '36px',
    letterSpacing: '-0.0015em',
  },
  KorolevHeavyH3: {
    fontFamily: Korolev,
    fontSize: 29.5,
    lineHeight: '28px',
  },
  KorolevHeavyH4: {
    fontFamily: Korolev,
    fontSize: 22.1,
    lineHeight: '22px',
  },
  headingLarge: {
    fontFamily: vars.typography.heading.large.fontFamily,
    fontSize: vars.typography.heading.large.fontSize,
    fontStyle: 'normal',
    fontWeight: 700,
    lineHeight: vars.typography.heading.large.lineHeight,
    letterSpacing: vars.typography.heading.large.letterSpacing,
  },
  bodyTextSmall: {
    fontFamily: vars.typography.bodyText.small.fontFamily,
    fontSize: vars.typography.bodyText.small.fontSize,
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: vars.typography.bodyText.small.lineHeight,
    letterSpacing: vars.typography.bodyText.small.letterSpacing,
  },
  bodyTextBoldSmall: {
    fontFamily: vars.typography.bodyText.small.fontFamily,
    fontSize: vars.typography.bodyText.small.fontSize,
    fontStyle: 'normal',
    fontWeight: 700,
    lineHeight: vars.typography.bodyText.small.lineHeight,
    letterSpacing: vars.typography.bodyText.small.letterSpacing,
  },
  labelMedium: {
    fontFamily: vars.typography.labels.medium.fontFamily,
    fontSize: vars.typography.labels.medium.fontSize,
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: vars.typography.labels.medium.lineHeight,
    letterSpacing: vars.typography.labels.medium.letterSpacing,
  },
  labelMediumBold: {
    fontFamily: vars.typography.labels.medium.fontFamily,
    fontSize: vars.typography.labels.medium.fontSize,
    fontStyle: 'normal',
    fontWeight: 700,
    lineHeight: vars.typography.labels.medium.lineHeight,
    letterSpacing: vars.typography.labels.medium.letterSpacing,
  },
  linksMedium: {
    fontFamily: vars.typography.links.medium.fontFamily,
    fontSize: vars.typography.links.medium.fontSize,
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: vars.typography.links.medium.lineHeight,
    letterSpacing: vars.typography.links.medium.letterSpacing,
    textDecoration: 'underline',
  },
  linksSmall: {
    fontFamily: vars.typography.links.small.fontFamily,
    fontSize: vars.typography.links.small.fontSize,
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: vars.typography.links.small.lineHeight,
    letterSpacing: vars.typography.links.small.letterSpacing,
    textDecoration: 'underline',
  },
  buttonsMedium: {
    fontFamily: vars.typography.buttons.medium.fontFamily,
    fontSize: vars.typography.buttons.medium.fontSize,
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: vars.typography.buttons.medium.lineHeight,
    letterSpacing: vars.typography.buttons.medium.letterSpacing,
  },
  headingSmall: {
    fontFamily: vars.typography.heading.small.fontFamily,
    fontSize: vars.typography.heading.small.fontSize,
    fontStyle: 'normal',
    fontWeight: 700,
    lineHeight: vars.typography.heading.small.lineHeight,
    letterSpacing: vars.typography.heading.small.letterSpacing,
  },
  labelsXSmall: {
    fontFamily: vars.typography.labels.xSmall.fontFamily,
    fontSize: vars.typography.labels.xSmall.fontSize,
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: vars.typography.labels.xSmall.lineHeight,
    letterSpacing: vars.typography.labels.xSmall.letterSpacing,
  },
  labelsMedium: {
    fontFamily: vars.typography.labels.medium.fontFamily,
    fontSize: vars.typography.labels.medium.fontSize,
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: vars.typography.labels.medium.lineHeight,
    letterSpacing: vars.typography.labels.medium.letterSpacing,
  },
  headingMedium: {
    fontFamily: vars.typography.heading.medium.fontFamily,
    fontSize: vars.typography.heading.medium.fontSize,
    fontStyle: 'normal',
    fontWeight: 700,
    lineHeight: vars.typography.heading.medium.lineHeight,
    letterSpacing: vars.typography.heading.medium.letterSpacing,
  },
  bodyTextMedium: {
    fontFamily: vars.typography.bodyText.medium.fontFamily,
    fontSize: vars.typography.bodyText.medium.fontSize,
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: vars.typography.bodyText.medium.lineHeight,
    letterSpacing: vars.typography.bodyText.medium.letterSpacing,
  },
  bodyTextMediumBold: {
    fontFamily: vars.typography.bodyText.mediumBold.fontFamily,
    fontSize: vars.typography.bodyText.mediumBold.fontSize,
    fontStyle: 'normal',
    fontWeight: 700,
    lineHeight: vars.typography.bodyText.mediumBold.lineHeight,
    letterSpacing: vars.typography.bodyText.mediumBold.letterSpacing,
  },
  bodyTextSmallBold: {
    fontFamily: vars.typography.bodyText.smallBold.fontFamily,
    fontSize: vars.typography.bodyText.smallBold.fontSize,
    fontStyle: 'normal',
    fontWeight: 700,
    lineHeight: vars.typography.bodyText.smallBold.lineHeight,
    letterSpacing: vars.typography.bodyText.smallBold.letterSpacing,
  },
  displayMedium: {
    fontFamily: vars.typography.display.medium.fontFamily,
    fontSize: vars.typography.display.medium.fontSize,
    fontStyle: 'normal',
    fontWeight: 900,
    lineHeight: vars.typography.display.medium.lineHeight,
    letterSpacing: vars.typography.display.medium.letterSpacing,
  },
  labelSmall: {
    fontFamily: vars.typography.labels.small.fontFamily,
    fontSize: vars.typography.labels.small.fontSize,
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: vars.typography.labels.small.lineHeight,
    letterSpacing: vars.typography.labels.small.letterSpacing,
  },
  buttonSmall: {
    fontFamily: vars.typography.buttons.small.fontFamily,
    fontSize: vars.typography.buttons.small.fontSize,
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: vars.typography.buttons.small.lineHeight,
    letterSpacing: vars.typography.buttons.small.letterSpacing,
  },
};

export const themeWithResponsiveTypography = (themeOptions: ThemeOptions, theme: Theme) => {
  return createTheme(themeOptions, {
    typography: {
      h1: {
        [theme.breakpoints.down('sm')]: {
          fontSize: 26.6,
          lineHeight: '32px',
        },
      },
      h2: {
        [theme.breakpoints.down('sm')]: {
          fontSize: 23,
          lineHeight: '24px',
          letterSpacing: '0.005em',
        },
      },
      h3: {
        [theme.breakpoints.down('sm')]: {
          fontSize: 20.3,
          lineHeight: '24px',
          letterSpacing: '0.01em',
        },
      },
      h4: {
        [theme.breakpoints.down('sm')]: {
          fontSize: 18,
          letterSpacing: '0.017em',
        },
      },
      h5: {
        [theme.breakpoints.down('sm')]: {
          fontSize: 16,
          letterSpacing: '0.015em',
        },
      },
      h6: {
        [theme.breakpoints.down('sm')]: {
          fontSize: 13.3,
          letterSpacing: '0.015em',
        },
      },
    },
  });
};
